import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { usePaymentFormContext } from '../context/PaymentFormContext';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { View } from 'foundations-components/components/View';
import { setErrorMessages, getShowAllErrors } from '../state/errorMessagesSlice';
import { useGetErrorMessagesAndTranslations } from '../hooks/useGetErrorMessagesAndTranslations';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentMethodOnFile = () => {
  const {
    formState,
    dispatch
  } = usePaymentFormContext();
  const reduxDispatch = useDispatch();
  const collectPaymentMethodOnFileAcknowledged = formState.get('collectPaymentMethodOnFileAcknowledged');
  const loading = formState.get('isCheckoutSubmitPending');
  const showAllErrors = useSelector(getShowAllErrors);
  const isError = showAllErrors && !collectPaymentMethodOnFileAcknowledged;
  useEffect(() => {
    reduxDispatch(setErrorMessages({
      collectPMOFNotAcknowledged: {
        isError
      }
    }));
  }, [isError, reduxDispatch]);
  const errorMessage = useGetErrorMessagesAndTranslations().get('collectPMOFNotAcknowledged');
  const handleAcknowledgementChanged = useCallback(event => {
    dispatch({
      type: 'setCollectPaymentMethodOnFileAcknowledged',
      data: event.target.checked
    });
  }, [dispatch]);
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "400",
    as: "div",
    children: /*#__PURE__*/_jsx(FormControl, {
      required: true,
      error: isError,
      validationMessage: isError && errorMessage,
      children: /*#__PURE__*/_jsx(Checkbox, {
        color: "icon-interactive-default",
        size: "small",
        checked: collectPaymentMethodOnFileAcknowledged,
        onChange: handleAcknowledgementChanged,
        disabled: loading,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.paymentMethodOnFile.simpleCheckbox"
        })
      })
    })
  });
};
export default PaymentMethodOnFile;